import { useMutation } from '@tanstack/react-query';

import UsersService, { UpdateAccountPayload } from '~/services/UsersService';

export function useUpdateAccount(accountId: string) {
  return useMutation({
    mutationFn: (payload: UpdateAccountPayload) => UsersService.updateAccount(accountId, payload),
  });
}
